import { Injectable } from "@angular/core";
import { IContextualMenu } from "src/app/common/models/contextual-menu.model";
import { DebitCardDetail } from "src/app/models/Debit-card-details.model";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { CustomerService } from "src/app/services/customer.service";
// { CustomerService } from '../customer.service';
import { HttpProviderService, HttpRequest } from "@fpx/core";
import { BehaviorSubject, map, Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
// import { DeviceDetectorService } from "ngx-device-detector";
import { CommonService } from "src/app/common.service";
import { MobileService } from "src/app/mobile.services";

@Injectable({
  providedIn: "root",
})
export class DebitCardsService {
  contextualMenuList: IContextualMenu[];
  menuList: any;
  dcList: any;
  private cardDtls = new BehaviorSubject({});
  dcDtls = this.cardDtls.asObservable();
  constructor(
    private _customerService: CustomerService,
    private _httpProvider: HttpProviderService,
    private _processShellService: ProcessShellService,
    protected _commonService: CommonService,
    private mobileService: MobileService
  ) {}

  cardDetails: Map<string, any> = new Map<string, any>();

  setUpMenu() {
      this.menuList = this.contextualMenuList = [
        
     ];
    if (!this._commonService.isHybrid()) {
    this.contextualMenuList = [
      {
      id: "DC001",
      icon: "Debit Card Details",
      name: "Card Details",
      title: "Card Details",
      path: ["process-shell", "debit-card", "dc-flash"],
      desktopPath: ["home","cards","process-shell", "debit-card", "dc-flash"],
      serviceCode: 'DCFLASH',
      processCode:'DCFLASH'
    },
      {
        id: "DC002",
        icon: "debit-card-change-pin",
        name: "Set/Change <em>PIN</em>",
        title: "Set/Change PIN",
        path: ["process-shell", "debit-card", "change-pin"],
        desktopPath: [
          "home",
          "cards",
          "process-shell",
          "debit-card",
          "change-pin",
        ],
        serviceCode: "DCCHANGEPIN",
        processCode: "DCCHANGEPIN",
        disabled: ["blocked", "inactive"],
      },
      /* {
      id: "DC003",
      icon: "credit-card-manage-service",//2z6
      name: "Card Control",
      title: "Card Control ",
      path: ["process-shell", "debit-card", "dc-services"],
      desktopPath: ["home","cards","process-shell", "debit-card", "dc-services"],
      serviceCode: 'DCMANAGESERVICE',
      processCode:'DCMANAGESERVICE',
      disabled: ['blocked', 'inactive']
    },*/
      /*{
      id: "DC004",
      icon: "credit-card-limit-increase",
      name: "Manage Limits",
      title: "Manage Limits",
      path: ["process-shell", "debit-card", "limit-increase"],
      desktopPath: ["home","cards","process-shell", "debit-card", "limit-increase"],
      serviceCode:'DCCHANGELIMIT',
      processCode:'DCCHANGELIMIT',
      disabled: ['blocked', 'inactive']
    },
    {
      id: "DC005",
      icon: "credit-card-block",
      name: "Block Card",
      title: "Block Card",
      path: ["process-shell", "debit-card", "dc-status"],
      desktopPath: ["home","cards","process-shell", "debit-card", "dc-status"],
      serviceCode:'DCSTATUS',
      processCode:'DCSTATUS',
      disabled: ['blocked', 'inactive']
    },
    {
      id: "DC006",
      icon: "credit-card-block",
      name: "Unblock Card",
      title: "Unblock Card",
      path: ["process-shell", "debit-card", "dc-unblock"],
      desktopPath: ["home","cards","process-shell", "debit-card", "dc-unblock"],
      serviceCode: 'DCUNBLOCK',
      processCode:'DCUNBLOCK',
      disabled: ['active', 'inactive']
    },
    {
      id: "DC007",
      icon: "debit-card-replacement",
      name: "Replace/Renew <em>card</em>",
      title: "Replace/Renew Card",
      path: ["process-shell", "debit-card", "replacement-card"],
      desktopPath: ["home","cards","process-shell", "debit-card", "replacement-card"],
      serviceCode: 'DCREPLACEMENT',
      processCode:'DCREPLACEMENT',
      disabled: ['blocked', 'inactive']
    }*/
    ];
     }

    if (this._commonService.isHybrid()) {
      this.contextualMenuList.push(
        {
        id: "DC003",
        icon: "debit-card-change-pin",
        name: "Card Details",
        title: "Card Details",
        path: ["process-shell", "debit-card", "change-pin"],
        desktopPath: [
          "home",
          "cards",
          "process-shell",
          "debit-card",
          "change-pin",
        ],
        serviceCode: "DCCARDDETAILS",
        processCode: "DCCARDDETAILS",
        disabled: ["blocked", "inactive"],
      },
            {
        id: "DC002",
        icon: "debit-card-change-pin",
        name: "Set/Change <em>PIN</em>",
        title: "Set/Change PIN",
        path: ["process-shell", "debit-card", "change-pin"],
        desktopPath: [
          "home",
          "cards",
          "process-shell",
          "debit-card",
          "change-pin",
        ],
        serviceCode: "DCCHANGEPIN",
        processCode: "DCCHANGEPIN",
        disabled: ["blocked", "inactive"],
      },
    );
    }

    if (
      this._commonService.isHybrid() &&
      this.mobileService.device.platform.toLowerCase() == "android" &&
      this.mobileService.isNFCPresent
    ) {
      this.contextualMenuList.push(
        {
          id: "DC008",
          icon: "debit-card-replacement",
          name: "Unregister for Tap to Pay",
          title: "Unregister for Tap to Pay",
          path: ["process-shell", "debit-card", "Unregister-card"],
          desktopPath: [
            "home",
            "cards",
            "process-shell",
            "debit-card",
            "Unregister-card",
          ],
          serviceCode: "DCUNREGISTER",
          processCode: "DCUNREGISTER",
          disabled: ["blocked", "inactive", "Unregister"],
        },
        {
          id: "DC009",
          icon: "debit-card-replacement",
          name: "Set default for Tap to Pay",
          title: "Set default for Tap to Pay",
          path: ["process-shell", "", ""],
          desktopPath: ["home", "cards", "process-shell", "debit-card", ""],
          serviceCode: "DCDEFAULTCARD",
          processCode: "DCDEFAULTCARD",
          disabled: ["blocked", "inactive", "Unregister"],
        }
      );
    }
    this.menuList = this.contextualMenuList;
    console.log("menuListTest", this.menuList);
  }
  getMenuList(): IContextualMenu[] {
    return this.contextualMenuList;
  }

  getSelectedMenuData(menuId: string) {
    const selectedMenuItem = this.contextualMenuList.find(
      (item) => item.id == menuId
    );
    return selectedMenuItem;
  }

  /**
   *
   * @param debitCardRefNumber
   * @returns
   */
  getDebitCardSummaryData(debitCardRefNumber: string): DebitCardDetail {
    return this._customerService
      .getDebitCardDetails()
      .find((item) => item.cardRefNumber == debitCardRefNumber);
  }

  /**
   *
   * @param debitCardRefNumber
   * @returns masked card number string
   */
  getCardNumber(debitCardRefNumber: string): string {
    const cardDetails = this._customerService
      .getDebitCardDetails()
      .find((item) => item.cardRefNumber == debitCardRefNumber);
    return cardDetails.cardNumber;
  }

  /**
   *
   * @returns
   */
  getInactiveCards(): DebitCardDetail[] {
    return this._customerService
      .getDebitCardDetails()
      .filter((item) => item.status == "Inactive");
  }

  fetchDetails(cardRefNumber: string): Observable<any> {
    if (!cardRefNumber) {
      return of(null);
    }
    if (this.cardDetails.has(cardRefNumber)) {
      return of(this.cardDetails.get(cardRefNumber));
    } else {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod("GET");
      httpRequest.setResource("/debitcard/{cardRefNumber}");
      httpRequest.addPathParameter("cardRefNumber", cardRefNumber);
      let bodyContent = {};
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.cardsPublisher);
      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: any) => {
          let result: DebitCardDetail = res.body?.debitcard;

          this.cardDetails.set(cardRefNumber, result);
          return result;
        })
      );
    }
  }
CardverifyClientAcc(): Observable<any> {
  this._commonService.showSpinner;
      const httpRequest = new HttpRequest();
      httpRequest.setMethod("GET");
      httpRequest.setResource("/account/validate");
      let bodyContent = {};
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.cardsPublisher);
      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: any) => {
          return res.body
        })
      );
  }
  triggerFormSubmitCopleted(result: any) {
    this._processShellService.processId = result?.processId;
    this._processShellService.triggerFormSubmittedCompleteStatus(result);
  }

  getDebitList(): DebitCardDetail[] {
    return this._customerService.getDebitCardDetails();
  }

  cardMethod(data: any) {
    this.cardDtls.next(data);
  }
}
